'use client';

import React, { useState } from 'react';
import { getNavigationForRole, NavItem } from '../../config/navigation';
import styles from './top-navigation.module.css';

interface TopNavigationProps {
  user: { Email: string; Name: string; Role: string };
  onLogout?: () => void;
}

export default function TopNavigation({ user, onLogout }: TopNavigationProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const phases = getNavigationForRole(user.Role);

  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        {/* Logo */}
        <a href="#/" className={styles.logoLink}>
          <h1 className={styles.logo}>🌊 FLOW</h1>
        </a>

        {/* Desktop Navigation */}
        <nav className={styles.desktopNav}>
          {phases.map((phase) => (
            <div key={phase.id} className={styles.navPhase}>
              <span className={styles.phaseLabel}>{phase.label}</span>
              <div className={styles.phaseItems}>
                {phase.items.map((item: NavItem) => (
                  <a
                    key={item.id}
                    href={`#${item.path}`}
                    className={styles.navItem}
                    title={item.label}
                  >
                    <span className={styles.itemIcon}>{item.icon}</span>
                    <span className={styles.itemLabel}>{item.label}</span>
                  </a>
                ))}
              </div>
            </div>
          ))}
        </nav>

        {/* Right Side - User Menu */}
        <div className={styles.rightSection}>
          <div className={styles.userMenuContainer}>
            <button
              className={styles.userButton}
              onClick={() => setUserMenuOpen(!userMenuOpen)}
            >
              <div className={styles.userInfo}>
                <div className={styles.userName}>{user.Name}</div>
                <div className={styles.userRole}>{user.Role}</div>
              </div>
              <svg
                className={`${styles.chevron} ${userMenuOpen ? styles.open : ''}`}
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M4 6L8 10L12 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            {userMenuOpen && (
              <div className={styles.userDropdown}>
                <button
                  className={styles.logoutItem}
                  onClick={() => {
                    setUserMenuOpen(false);
                    onLogout?.();
                  }}
                >
                  Logout
                </button>
              </div>
            )}
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className={styles.mobileMenuToggle}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            ☰
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <nav className={styles.mobileNav}>
          {phases.map((phase) => (
            <div key={phase.id} className={styles.mobilePhase}>
              <div className={styles.mobilePhaseLabel}>{phase.label}</div>
              {phase.items.map((item: NavItem) => (
                <a
                  key={item.id}
                  href={`#${item.path}`}
                  className={styles.mobileNavItem}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <span className={styles.itemIcon}>{item.icon}</span>
                  <span className={styles.itemLabel}>{item.label}</span>
                </a>
              ))}
            </div>
          ))}
        </nav>
      )}
    </header>
  );
}
